<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <i class="el-icon-caret-bottom" />
          <span class="local-time">{{ localTime }} {{ zoneStr }}</span>
          <span class="name-box">{{ name || '商户' }} {{ accountName }}</span>
        </div>

        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item>首页</el-dropdown-item>
          </router-link>
          <router-link v-if="accountRant === 0" to="/account">
            <el-dropdown-item>账号</el-dropdown-item>
          </router-link>
          <el-dropdown-item divided @click.native="logout">
            <span style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import commonFn from '@/assets/javascripts/common_function.js';
import { mapGetters } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import Hamburger from '@/components/Hamburger/Hamburger';
import LangSelect from '@/components/LangSelect';

export default {
  components: {
    Breadcrumb,
    Hamburger,
    LangSelect,
  },
  data() {
    return {
      localTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
      zoneStr: '',
    };
  },
  computed: {
    ...mapGetters(['sidebar', 'avatar', 'name', 'accountName']),
    // 账号权限 0-超级管理员 1-管理员 2-LinkieMall超级管理员
    accountRant() {
      return Number(commonFn.getCookie('accountRant'));
    }
  },
  mounted() {
    console.log(this.accountName, this.name);
    const that = this;
    this.timeInterval = setInterval(() => {
      that.localTime = that.$moment().format('YYYY-MM-DD HH:mm:ss');
    }, 1000);
    // this.zoneStr = this.computeZone();
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  methods: {
    // computeZone() {
    //   const date = new Date();
    //   const offset = date.getTimezoneOffset();
    //   const zoneNumber = offset / 60;
    //   let location = '';
    //   if (zoneNumber > 0) {
    //     location = '西';
    //   } else {
    //     location = '东';
    //   }
    //   const numberTransMap = {
    //     '1': '一',
    //     '2': '二',
    //     '3': '三',
    //     '4': '四',
    //     '5': '五',
    //     '6': '六',
    //     '7': '七',
    //     '8': '八',
    //     '9': '九',
    //     '10': '十',
    //     '11': '十一',
    //     '12': '十二',
    //   };
    //   return `(${location}${numberTransMap[Math.abs(zoneNumber)]}区)`;
    // },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        cursor: pointer;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 20px;
          font-size: 12px;
        }
      }
    }
  }

  .local-time {
    margin-right: 5px;
  }
}
</style>
